class AppConstants {
    static drawerWidth = 250;
    static JWT = "JWT";
}
export default AppConstants;
